import React from 'react';
import { Label, MaskedField, ErrorMessage } from '../FormikCustom';

export default function SSNumberFull({ name, label, required, ...rest }) {
  return (
    <div className="form-group">
      <Label required={required} htmlFor={name}>{label}</Label>
      <MaskedField
        mask="999-99-9999"
        className="form-control"
        placeholder="ex. 123-12-1234"
        name={name}
    
        {...rest}
      />
      <ErrorMessage name={name} />
    </div>
  );
}
